import { applyMiddleware, combineReducers, createStore, compose } from "redux";
import thunk from "redux-thunk";
import { filtersearchglobal } from "./filtersearch/filtersearh.reducer";
import { FormActionReducer } from "./FormsData/FormFieldData/FormFieldData.reducer";
import { LoginReducer } from "./login/Login.reducer";
import { NavbarStateReducer } from "./NavbarState/NavbarState.reducer";
import { authReducer } from "./Auth/auth.reducer";
import { userRightsReducer } from "./UserRights/UserRights.reducer";
import { TableDataReducer } from "./TableData/TableData.reducer";
import { SelectedTabData } from "./SelectedTabData/SelectedTabData.reducer";
import { MessageStoreReducer } from "./Messagestore/MessageStore.reducer";
import { GSTFormulaReducer } from "./GSTFormula/GSTFormula.reducer";
import { LicenseeRightsData } from "./LicenseeRights/LicenseeRights.reducer";
import { LrPickupMemo } from "./LrPickupMemo/LRpickupMemo.reducer";
import { ColumnManagementReducer } from "./ColumnManagement/ColumnManagement";
import { OriginalTableData } from "./Originaldata/OriginalData";
import { UniqueTableReducer } from "./UniqTableData/UniqTableData";
import { financialYearReducer } from "./FinancialDates/FinancialDates.reducer";
import { FormDataReducer } from "./FormDataReducer/FormDataReducer";
import { ComponentPropReducer } from "./ComponentProp/ComponentProp.reducer";

import { UniqueTabReducer } from "./TabData/Tabdata";
import { BookingBrokerReducer } from "./BookingBroker/BookingBroker.reducer";

const rootReducer = combineReducers({
  login: LoginReducer,
  search: filtersearchglobal,
  sidebarOpen: NavbarStateReducer,
  FormFieldData: FormActionReducer,
  AuthReducer: authReducer,
  userRightsReducer: userRightsReducer,
  TableDataReducer: TableDataReducer,
  SelectedTabData: SelectedTabData,
  MessageStoreReducer: MessageStoreReducer,
  GSTFormulaReducer: GSTFormulaReducer,
  LicenseeRightsData: LicenseeRightsData,
  LrPickupMemo: LrPickupMemo,
  ColumnManagementReducer: ColumnManagementReducer,
  OriginalTableData: OriginalTableData,
  UniqueTableReducer: UniqueTableReducer,
  financialYear: financialYearReducer,
  FormDataReducer: FormDataReducer,
  ComponentPropReducer: ComponentPropReducer,
  UniqueTabReducer:UniqueTabReducer,
  BookingBrokerVoucherData: BookingBrokerReducer,
});
const createCompose =
  (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 })) ||
  compose;
export const store = createStore(rootReducer, createCompose(applyMiddleware(thunk)));
